export default __webpack_public_path__ + "static/media/suitcase@3x.6344177c.png";